<template>

		 <el-container class="bgcolor">
		   <el-row style="margin:12% auto;width: 100%;" type="flex" justify="center">
			   <el-card>
			   <div style="margin:30px auto;width: 350px;text-align: center;" >
				   
				<h1 style="height: 3.5rem; font-size: 32px;text-align: center; margin-bottom: 1rem;font-weight: 400">欢迎登录后台管理</h1>
				 <div class="divbgFill" style="height: 55px; background-image: url(/img/webimg/zh.png);">
				 
				 	&emsp;<el-input class="inputDelBorder"
				 		style="font-size: 18px;margin-top:8px; width: 200px;" type="text" v-model="LoginNo"
				 		placeholder="请输入账号"></el-input>
				 
				 </div>
				 <br>
				 <div class="divbgFill" style="height: 55px;background-image: url(/img/webimg/mm.png);">
				 
				 	&emsp;<el-input class="inputDelBorder"
				 		style="font-size: 18px; margin-top:8px; width: 200px;" type="password" v-model="Pwd"
				 		placeholder="请输入密码"></el-input>
				 
				 </div><br>
				<el-button round style="width: 95%;font-size: 20px;" type="primary"
					@click="submitForm($event)">登&emsp;录</el-button>
				<!-- <el-button round type="primary" style="width: 250px;"  @click="submitForm($event)">登录</el-button> -->
				</div>
				</el-card>
			</el-row>
		</el-container>
</template>

<script>
	import Vue from 'vue'
	import user from '../apifunction/User.js'
	import commfun from '../commontools/CommonFun.js';
	export default {
		beforeMount() {
			this.$store.commit('$_removeStorage');
			//alert(JSON.stringify(this.$myglobal.getUserInfo()) )
		},
		// directives: { //自定义的v-focus指令
		//             focus: {
		//                 inserted: function (el, {value}) {
		//                     if (value) {
		//                         //$(el).find("input").focus();//聚焦输入框
		//                          el.focus();
		//                     }
		//                 }
		//             }
		//         },
		// mounted(){
		// 	this.$refs.no.focus();
		// },
		data() {
			return { 
				LoginNo: '',
				Pwd: '',
				num:1
			}
		},
		methods: {
			submitForm: function(event) {
				// event.preventDefault();
				if(this.LoginNo==''||this.Pwd=='')
				{
					this.$message.success('请输入账号和密码！')
					return;
				}
				this.$store.commit('$_removeStorage'); 
				user.CanLogin(this.LoginNo, this.Pwd)
					.then(res => {
						let ent=JSON.parse(JSON.stringify(res.data))
						if (ent.Flag=='success') {
							let entdata=JSON.parse(ent.Data)
							this.$myglobal.setUserInfo(entdata.userinfo)
							this.$myglobal.userinfo=JSON.parse(entdata.userinfo)[0];
							this.$store.commit('$_setToken', entdata.token);
							this.$router.push('main');
						} else
							this.$message.info("账号或密码不对！");
					})
					.catch(err => {

					});


			}
		}
	}
</script>

<style>
	*{
		margin: 0;
		padding: 0;
	}
	#login{
		/* background:url(../assets/bg.jpg) no-repeat; */
		background-position: center;
		background-size: cover;
		min-height: 100vh;
	}
	.text-box {
		margin-bottom: 40upx;
		padding: 40upx 0;
		display: flex;
		min-height: 300upx;
		background-color: #FFFFFF;
		justify-content: center;
		align-items: center;
		text-align: center;
		font-size: 30upx;
		color: #353535;
		line-height: 1.8;
	}
</style>
